export default "__VITE_ASSET__N2uNWjC5__"